/**
 * Component Registry for Cambria Luxury Apartment Homes
 * 
 * Inherits from @vibesites-price-brothers/theme-vantage and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-price-brothers/theme-vantage/registry';
import { ContactForm } from './components/ContactForm';
import { FloorplansList } from './components/FloorplansList';
import { Hero } from './components/Hero';
import { HeroSolidBG } from './components/HeroSolidBG';
import { NeighborhoodMap } from './components/NeighborhoodMap';
import { NeighborhoodSection } from './components/NeighborhoodSection';
import { PageBlurb } from './components/PageBlurb';
import { PreferredEmployerCTA } from './components/PreferredEmployerCTA';
import { PropertyOverview } from './components/PropertyOverview';
import { ScheduleTourForm } from './components/ScheduleTourForm';
import { SisterProperties } from './components/SisterProperties';

/**
 * Property-specific component overrides.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  ContactForm,
  FloorplansList,
  Hero,
  HeroSolidBG,
  NeighborhoodMap,
  NeighborhoodSection,
  PageBlurb,
  PreferredEmployerCTA,
  PropertyOverview,
  ScheduleTourForm,
  SisterProperties,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
